import React from 'react';

export default function OrderDashboardStats({
  totalMatching,
  dateFilter,
  selectedStatus,
  setSelectedStatus,
  selectedType,
  setSelectedType,
  statusCounts,
  hasNonIndianOrders,
}) {
  return (
    <div className="stats-container">
  <div 
    className={`stat-card clickable ${selectedStatus === 'all' ? 'active' : ''}`}
    onClick={() => setSelectedStatus('all')}
    title="Click to show all orders"
  >
    <h3>Total Orders</h3>
    <span className="stat-number">{totalMatching}</span>
    <div className="stat-subtitle">
      {dateFilter === 'all' ? 'All Time' :
       dateFilter === 'today' ? 'Today' :
       dateFilter === '7days' ? 'Last 7 Days' :
       dateFilter === '1month' ? 'Last 1 Month' :
       dateFilter === '3months' ? 'Last 3 Months' :
       dateFilter === 'custom' ? 'Custom Range' : ''}
    </div>
    <div className="click-indicator">Click to filter</div>
  </div>

  <div 
    className={`stat-card clickable ${selectedStatus === 'unfulfilled' ? 'active' : ''}`}
    onClick={() => setSelectedStatus('unfulfilled')}
    title="Click to show only Order Placed orders"
  >
    <h3>Order Placed</h3>
    <span className="stat-number" style={{color: '#ff5722'}}>
      {(statusCounts.unfulfilled || 0)}
    </span>
    <div className="click-indicator">Click to filter</div>
  </div>
  
  <div 
    className={`stat-card clickable preorder-card ${selectedStatus === 'stock_in' ? 'active' : ''}`}
    onClick={() => setSelectedStatus('stock_in')}
    title="Click to show only Stock Arrived orders"
  >
    <h3>Stock Arrived</h3>
    <span className="stat-number" style={{color: '#2e7d32'}}>
      {(statusCounts.stock_in || 0)}
    </span>
    <div className="click-indicator">Click to filter</div>
  </div>
  
  <div 
    className={`stat-card clickable ${selectedStatus === 'packing' ? 'active' : ''}`}
    onClick={() => setSelectedStatus('packing')}
    title="Click to show only Packing Started orders"
  >
    <h3>Packing Started</h3>
    <span className="stat-number" style={{color: '#ff9800'}}>
      {(statusCounts.packing || 0)}
    </span>
    <div className="click-indicator">Click to filter</div>
  </div>
  <div 
    className={`stat-card clickable ${selectedStatus === 'shipping_domestic' ? 'active' : ''}`}
    onClick={() => setSelectedStatus('shipping_domestic')}
    title="Click to show only Shipped Domestic orders"
  >
    <h3>Shipped Domestic</h3>
    <span className="stat-number" style={{color: '#2196f3'}}>
      {(statusCounts.shipping_domestic || 0)}
    </span>
    <div className="click-indicator">Click to filter</div>
  </div>
  {/* Show International Shipping stats only if there are non-Indian orders */}
  {hasNonIndianOrders() && (
    <div 
      className={`stat-card clickable ${selectedStatus === 'shipping_international' ? 'active' : ''}`}
      onClick={() => setSelectedStatus('shipping_international')}
      title="Click to show only Shipped International orders"
    >
      <h3>Shipped International</h3>
      <span className="stat-number" style={{color: '#2196f3'}}>
        {(statusCounts.shipping_international || 0)}
      </span>
      <div className="click-indicator">👆 Click to filter</div>
    </div>
  )}
  <div 
    className={`stat-card clickable ${selectedStatus === 'arrived_at_destination' ? 'active' : ''}`}
    onClick={() => setSelectedStatus('arrived_at_destination')}
    title="Click to show only Arrived in Destination Country orders"
  >
    <h3>Arrived in Destination Country</h3>
    <span className="stat-number" style={{color: '#1976d2'}}>
      {(statusCounts.arrived_at_destination || 0)}
    </span>
    <div className="click-indicator">Click to filter</div>
  </div>
  <div 
    className={`stat-card clickable ${selectedStatus === 'out_of_delivery' ? 'active' : ''}`}
    onClick={() => setSelectedStatus('out_of_delivery')}
    title="Click to show only Out for Delivery orders"
  >
    <h3>Out for Delivery</h3>
    <span className="stat-number" style={{color: '#0288d1'}}>
      {(statusCounts.out_of_delivery || 0)}
    </span>
    <div className="click-indicator">Click to filter</div>
  </div>
  <div 
    className={`stat-card clickable ${selectedStatus === 'destoryed' ? 'active' : ''}`}
    onClick={() => setSelectedStatus('destoryed')}
    title="Click to show only Customs Cleared orders"
  >
    <h3>Customs Cleared</h3>
    <span className="stat-number" style={{color: '#388e3c'}}>
      {(statusCounts.destoryed || 0)}
    </span>
    <div className="click-indicator">Click to filter</div>
  </div>
  <div 
    className={`stat-card clickable ${selectedStatus === 'delivered' ? 'active' : ''}`}
    onClick={() => setSelectedStatus('delivered')}
    title="Click to show only Delivered orders"
  >
    <h3>Delivered</h3>
    <span className="stat-number" style={{color: '#4caf50'}}>
      {(statusCounts.delivered || 0)}
    </span>
    <div className="click-indicator">👆 Click to filter</div>
  </div>

  <div 
    className={`stat-card clickable preorder-card ${selectedType === 'preorder' ? 'active' : ''}`}
    onClick={() => setSelectedType('preorder')}
    title="Click to show only Preorders"
  >
    <h3>Preorders</h3>
    <span className="stat-number" style={{color: '#9c27b0'}}>
      {(statusCounts.preorder_received || 0)}
    </span>
    <div className="click-indicator">👆 Click to filter</div>
  </div>

</div>
  );
}
